'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';

export interface SectionLabelProps {
  icon: React.ReactNode;
  label: string;
  action?: React.ReactNode;
}

/**
 * 섹션 헤더 (아이콘 + 라벨)
 */
export function SectionLabel({ icon, label, action }: SectionLabelProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 0.75,
        borderBottom: '1px solid',
        borderColor: 'divider',
        mb: 0.5,
      }}
    >
      <Box sx={{ color: 'primary.main', display: 'flex', '& .MuiSvgIcon-root': { fontSize: 16 } }}>
        {icon}
      </Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.8125rem', flex: 1 }}>
        {label}
      </Typography>
      {action}
    </Box>
  );
}
